<template>
  <v-dialog
    v-model="showZoomedImage"
  >
    <template #activator="{ on: onDialog }">
          <v-tooltip top>
            <template #activator="{ on: onToolTip }">
              <v-img v-on="getHandlers(onDialog, onToolTip)" :src="src" :lazy-src="src" :width="smallWidth" :max-width="smallWidth" class="my-3 mx-auto"/>
            </template>
            <span>Click on the image to zoom</span>
          </v-tooltip>
    </template>
    <v-card>
      <v-card-actions>
        <v-spacer/>
        <v-btn
            icon
            @click="showZoomedImage = false"
          >
          <v-icon color="primary">mdi-close</v-icon>
        </v-btn>
      </v-card-actions>
      <v-card-text>
        <v-container>
          <v-row justify="center">
            <v-col class="flex-grow-0">
              <v-img :src="src" width="auto" contain/>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ImageViewer',
  props: {
    smallWidth: {
      type: Number
    },
    src: {
      type: String
    },
    inline: {
      type: Boolean,
      default: () => false
    }
  },
  data: () => ({
    showZoomedImage: false
  }),
  methods: {
    getHandlers () {
      return [...arguments].reduce((seed, item) => {
        return {...item, ...seed}
      }, {})
    }
  }
}
</script>

<style scoped>

</style>
